import React from "react";
import styled from "styled-components";
import Heading from "../../shared/Heading";
import theme from "../../assets/styles/theme/theme";
import LinkComponent from "../../shared/Link";
import BrowserCompatibility from "../../shared/BrowserCompatibility";
import { MainContainer } from "../../assets/styles/theme/styles";

export default function Globe({
  heading,
  helpItems,
  img,
  fgvideo,
  link,
  video,
}) {
  return (
    <MainContainer>
      <HeroContainer>
        <FlexItem width="53%">
          <Heading level={1}>{heading}</Heading>
          <div style={{ marginTop: "2rem" }}>
            {helpItems.map((ele, ind) => (
              <FlexContainer2 key={ind}>
                <TextWrapper>
                  <Heading level={3}>{ele.heading}</Heading>
                  {ele.sectionHeading && (
                    <Heading level={3} color={theme.colors.secondary}>
                      {ele.sectionHeading}
                    </Heading>
                  )}
                  <p>{ele.description}</p>
                </TextWrapper>
              </FlexContainer2>
            ))}
            {link && <LinkComponent text={`Learn more`} />}
          </div>
        </FlexItem>

        <FlexItem>
          {!video && <GlobeImage src={img} alt="" />}
          {video && (
            // <video width="580" autoPlay loop muted>
            //   <source src={fgvideo} type="video/webm" />
            //   Your browser does not support the video tag.
            // </video>
            <BrowserCompatibility image={img} video={fgvideo} />
          )}
        </FlexItem>
      </HeroContainer>
    </MainContainer>
  );
}

const HeroContainer = styled.div`
  padding: 30px 0px;
  // max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 720px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 3.5rem;
  }
`;

const FlexItem = styled.div`
  flex-basis: ${(props) => props.width || "auto"};

  video {
    width: 100%;

    @media (min-width: 720px) {
      width: 580px;
    }
  }

  img {
    width: 100%;

    @media (min-width: 720px) {
      width: 580px;
    }

  
`;

const GlobeImage = styled.img`
  width: 300px;
  height: auto;
`;

const FlexContainer2 = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 2.3rem;
  gap: 2rem;
`;

const TextWrapper = styled.div`
  text-align: center;
  @media (min-width: 1020px) {
    text-align: left;
  }

  > p {
    line-height: 1.6em;
  }
  > h3 {
    margin-bottom: 12px;
  }
`;
